<template>
  <div class="calculator">
    <div class="header">
      <h1>IRR Calculator</h1>
      <router-link to="/withdraw" class="withdraw-link">Withdraw</router-link>
    </div>

    <!-- Modified currency selection box -->
    <div class="currency-container">
      <label for="currency">Currency:</label>
      <select v-model="selectedCurrency" id="currency" class="currency-select">
        <option value="USD">USD</option>
        <option value="CNY">CNY</option>
        <option value="Other">Other</option>
      </select>
    </div>
    <br />

    <form @submit.prevent="calculateRate">
      <div class="form-group">
        <label for="currentAge">Current Age</label>
        <input type="number" v-model="currentAge" id="currentAge" required />
      </div>
      <div class="form-group">
        <label for="annualPayment">Annual Payment</label>
        <input
          type="number"
          v-model="annualPayment"
          id="annualPayment"
          required
        />
      </div>
      <div class="form-group">
        <label for="paymentYears">Payment Years</label>
        <input
          type="number"
          v-model="paymentYears"
          id="paymentYears"
          required
        />
      </div>
      <div class="form-group">
        <label for="targetAge">Target Age</label>
        <input type="number" v-model="targetAge" id="targetAge" required />
      </div>
      <div class="form-group">
        <label for="targetReturnValue">Target Return Value</label>
        <input
          type="number"
          v-model="targetReturnValue"
          id="targetReturnValue"
          required
        />
      </div>
      <button type="submit" class="calculate-button">
        Calculate Return Rate
      </button>
    </form>

    <!-- New text area for results -->
    <textarea
      v-model="resultsText_sc"
      class="results-area-sc"
      readonly
    ></textarea>

    <!-- New text area for results -->
    <textarea
      v-model="resultsText_tc"
      class="results-area-tc"
      readonly
    ></textarea>

    <!-- New Clear button -->
    <!-- <button @click="clearResults" class="clear-button">Clear Results</button> -->

    <!-- Button container for Clear and Copy buttons -->
    <div class="button-container">
      <button @click="clearResults" class="action-button clear-button">
        Clear
      </button>
      <button @click="copyToClipboard('sc')" class="action-button copy-button">
        Copy SC
      </button>
      <button @click="copyToClipboard('tc')" class="action-button copy-button">
        Copy TC
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // selectedCurrency: 'USD',
        // resultsText_sc: '',
        // resultsText_tc: '',
      }
    },
    computed: {
      selectedCurrency: {
        get() {
          return this.$store.state.selectedCurrency
        },
        set(value) {
          this.$store.commit('setSelectedCurrency', value)
        },
      },
      resultsText_sc:{
        get() {
          return this.$store.state.resultsText_sc
        },
        set(value) {
          this.$store.commit('setResultsText_sc', value)
        },
      },
      resultsText_tc: {
        get() {
          return this.$store.state.resultsText_tc
        },
        set(value) {
          this.$store.commit('setResultsText_tc', value)
        },
      },
      
      currentAge: {
        get() {
          return this.$store.state.currentAge
        },
        set(value) {
          this.$store.commit('setCurrentAge', value)
        },
      },
      annualPayment: {
        get() {
          return this.$store.state.annualPayment
        },
        set(value) {
          this.$store.commit('setAnnualPayment', value)
        },
      },
      paymentYears: {
        get() {
          return this.$store.state.paymentYears
        },
        set(value) {
          this.$store.commit('setPaymentYears', value)
        },
      },
      targetAge: {
        get() {
          return this.$store.state.targetAge
        },
        set(value) {
          this.$store.commit('setTargetAge', value)
        },
      },
      targetReturnValue: {
        get() {
          return this.$store.state.targetReturnValue
        },
        set(value) {
          this.$store.commit('setTargetReturnValue', value)
        },
      },
    },
    methods: {
      presentValueSinglePayment(payment, rate, year) {
        return payment / (1 + rate) ** year
      },
      calculateTotalPresentValue(annualPayment, paymentYears, rate) {
        const presentValues = []
        for (let year = 0; year < paymentYears; year++) {
          presentValues.push(
            this.presentValueSinglePayment(annualPayment, rate, year)
          )
        }
        return presentValues.reduce((acc, val) => acc + val, 0)
      },

      
      findDiscountRate(
        targetValue,
        annualPayment,
        paymentYears,
        duration,
        tolerance = 1,
        maxIterations = 1000
      ) {
        let lowRate = 0.0
        let highRate = 1.0
        let iterations = 0
        while (iterations < maxIterations) {
          const midRate = (lowRate + highRate) / 2
          const totalPresentValue = this.calculateTotalPresentValue(
            annualPayment,
            paymentYears,
            midRate
          )
          const presentValueOfReturn = this.presentValueSinglePayment(
            targetValue,
            midRate,
            duration
          )
          const difference = presentValueOfReturn - totalPresentValue
          if (Math.abs(difference) < tolerance) {
            return {
              discountRate: midRate,
              totalPresentValue,
              presentValueOfReturn,
            }
          }
          if (difference > 0) {
            lowRate = midRate
          } else {
            highRate = midRate
          }
          iterations++
        }
        return null
      },

      calculateRate() {
        const duration = this.targetAge - this.currentAge
        const result = this.findDiscountRate(
          this.targetReturnValue,
          this.annualPayment,
          this.paymentYears,
          duration
        )
        this.$store.commit('setResult', result)

        // // Add the new result to the text area
        // const newResult = `複利 IRR: ${(result.discountRate * 100).toFixed(
        //   2
        // )}%\n`
        // this.resultsText += newResult

        // // Format the new result with the requested information
        // const newResult_sc = `${this.targetAge} 岁时，保单价值增加到 USD ${(
        //   this.targetReturnValue / 10000
        // ).toFixed(2)} 万元，复利 IRR ${(result.discountRate * 100).toFixed(
        //   4
        // )}%\n\n`

        // const newResult_tc = `${this.targetAge} 歲時，保單價值增加到 USD ${(
        //   this.targetReturnValue / 10000
        // ).toFixed(2)} 萬元，複利 IRR ${(result.discountRate * 100).toFixed(
        //   4
        // )}%\n\n`

        const currencySymbol =
          this.selectedCurrency === 'Other' ? '' : this.selectedCurrency + ' '

        const newResult_sc = `${
          this.targetAge
        } 岁时，保单价值增加到 ${currencySymbol}${(
          this.targetReturnValue / 10000
        ).toFixed(2)} 万元，复利 IRR ${(result.discountRate * 100).toFixed(
          4
        )}%\n\n`

        const newResult_tc = `${
          this.targetAge
        } 歲時，保單價值增加到 ${currencySymbol}${(
          this.targetReturnValue / 10000
        ).toFixed(2)} 萬元，複利 IRR ${(result.discountRate * 100).toFixed(
          4
        )}%\n\n`

        // this.resultsText_sc += newResult_sc
        // this.resultsText_tc += newResult_tc

        this.resultsText_sc += newResult_sc
        this.resultsText_tc += newResult_tc

        // Optionally, still navigate to the results page
        // this.$router.push({ name: 'MyResult', query: { result: JSON.stringify(result) } });
      },

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

      clearResults() {
        this.resultsText_sc = ''
        this.resultsText_tc = ''
      },

      copyToClipboard(args) {
        if (args === 'sc') {
          navigator.clipboard
            .writeText(this.resultsText_sc)
            .then(() => {
              alert('SC Results copied to clipboard!')
            })
            .catch((err) => {
              console.error('Failed to copy text: ', err)
              alert('Failed to copy to clipboard. Please try again.')
            })
        } else if (args === 'tc') {
          navigator.clipboard
            .writeText(this.resultsText_tc)
            .then(() => {
              alert('TC Results copied to clipboard!')
            })
            .catch((err) => {
              console.error('Failed to copy text: ', err)
              alert('Failed to copy to clipboard. Please try again.')
            })
        }
      },
    },

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  }
</script>

<style scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .withdraw-link {
    background-color: #4caf50;
    color: white;
    padding: 10px 15px;
    text-decoration: none;
    border-radius: 5px;
    font-size: 16px;
  }

  .withdraw-link:hover {
    background-color: #45a049;
  }

  .currency-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 18px;
  }

  .currency-container label {
    margin-right: 10px;
    font-weight: bold;
  }

  .currency-select {
    flex-grow: 1;
    padding: 10px;
    font-size: 18px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #333;
    color: white;
  }

  /* Adjust other input styles to match */
  input,
  .calculate-button {
    font-size: 18px;
    padding: 12px;
  }

  /* Adjust label styles for consistency */
  label {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .calculator {
    padding: 10px;
    /* max-width: 480px; */
    margin: 0 auto;
    font-family: Arial, sans-serif;
  }

  h1 {
    text-align: center;
    font-size: 24px;
    margin-bottom: 30px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  label {
    display: block;
    margin-top: 5px;
    /* margin-bottom: 5px; */
  }

  input {
    width: 90%;
    margin: 5px;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .calculate-button {
    width: 96%;
    margin-top: 15px;
    padding: 10px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .calculate-button:hover {
    background-color: #0056b3;
  }

  .results-area-sc {
    width: 90%;
    height: 100px;
    margin: 20px 5px;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
  }

  .results-area-tc {
    width: 90%;
    height: 100px;
    /* margin: 20px 5px; */
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: vertical;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    /* justify-content: center;  */
    margin-left: 20px;
    margin-right: 20px;
    padding: 10px;
  }

  .action-button {
    width: 32%;
    padding: 10px;
    font-size: 16px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .clear-button {
    background-color: #dc3545;
  }

  .clear-button:hover {
    background-color: #c82333;
  }

  .copy-button {
    background-color: #28a745;
  }

  .copy-button:hover {
    background-color: #218838;
  }
</style>
